import { Controller } from '@hotwired/stimulus'

// <%= f.text_field :time_of_birth, 'data-controller': 'timepicker' %>
export default class extends Controller {
  initialize() {
    console.log('timepicker#initialize')
    $(this.element).timepicker()
  }
}
